import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  margin-bottom: 50px;
  background-color: #f5f5f5;
  box-shadow: 0 10px 100px rgba(0, 0, 0, 0.05);

  @media (max-width: 576px) {
    margin-bottom: 30px;
  }
`;

export const InnerMain = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 0;
`;

export const AdminLogo = styled(Link)`
  font-size: 35px;
  font-weight: 700;
  font-family: font-bold;
  color: #5da6ed;
  text-decoration: none;
  user-select: none;

  @media (max-width: 576px) {
    font-size: 25px;
  }
`;

export const LogoutButton = styled.div`
  font-size: 22px;
  font-weight: 600;
  font-family: font-semibold;
  color: #5da6ed;
  cursor: pointer;
  user-select: none;

  @media (max-width: 576px) {
    font-size: 18px;
  }
`;
